module.exports = __webpack_public_path__ + "static/amir-fd636cd87829ba12d351422ba622e535.png";